import Vue from 'vue'
import Vuex from 'vuex'

import bmap from './bmap'
import common from './common'
import coupon from './coupon'
import customer from './customer'
import dataList from './dataList'
import label from './search/label'
import order from './order'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bmap,
    common,
    coupon,
    customer,
    dataList,
    label,
    order
  }
})
